import React, { Component } from "react";
import styled from "styled-components";

class PanelWrapper extends Component {
  render() {
    return (
      <Wrapper color={this.props.color} padding={this.props.padding}>
        {this.props.children}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  background: ${props => props.color || "rgba(0,0,0,0.85)"};
  display: block;
  margin: 0 0 20px 0;
  padding: ${props => props.padding || "10px"};
  font-family: "Bree Serif", serif;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  @media only screen and (max-width: 980px) {
    width: initial;
    margin: 0 5px 10px 5px;
    padding: ${props => props.padding || "10px"};
    display: block;
  }
`;

export default PanelWrapper;



// WEBPACK FOOTER //
// ./src/components/layout/PanelWrapper.js